import React from 'react';

import { createPaginationClassName } from './paginationStyles';

export const PaginationWrapper: React.FC = ({ children }) => (
  <div className={createPaginationClassName('wrapper')}>{children}</div>
);
